
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import { getRateLimit } from '../../actions/request_actions'

import { login, googleLogin, signup, logout } from '../../actions/session_actions';

import { forgotPassword } from '../../actions/user_actions';

import { fetchAllNotifications, fetchUnreadCount } from '../../actions/notification_actions'

import LoginPage from './login_page';

const mapStateToProps = (state, ownProps) => {

  const loggedIn = Boolean(state.session.currentUser)
  let currentUser = loggedIn ? state.session.currentUser : null;
  let errors = state.errors.session;

  return {
    currentUser,
    loggedIn,
    errors
  };
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  signup: user => dispatch(signup(user)),
  login: user => dispatch(login(user)),
  googleLogin: token => dispatch(googleLogin(token)),
  fetchAllNotifications: user => dispatch(fetchAllNotifications(user)),
  fetchUnreadCount: user => dispatch(fetchUnreadCount(user)),
  getRateLimit: () => dispatch(getRateLimit()),
  forgotPassword: data => dispatch(forgotPassword(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginPage));
